const category = 'distortion';

const baseUrl = `/short/content/2018/distortion`;

const virtualPush = (params, title) => {
    window.dataLayer.push({
        'event': 'virtualPageview',
        'virtualPageURL': `${baseUrl}${params}?prof=538.Entertaiment-distortion`,
        'virtualPageTitle': title
    });
}
const push = (action, label) => {
    window.dataLayer.push({
        'event': 'GA_Event',
        'Category': category,
        'Action': action,
        'Label': label
    });
}

export {
    push,
    virtualPush
}


// WEBPACK FOOTER //
// ./src/analytics.js